export class ResourceReference {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceReference.attributeTypeMap;
    }
    constructor() {
    }
}
